"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthenticatedCirrus = void 0;
const react_1 = require("react");
const AuthenticatedCirrusContext_1 = require("../contexts/AuthenticatedCirrusContext");
const useCirrus_1 = require("./useCirrus");
function useAuthenticatedCirrus() {
    const cirrus = useCirrus_1.useCirrus();
    const authenticatedCirrus = react_1.useContext(AuthenticatedCirrusContext_1.AuthenticatedCirrusContext);
    return react_1.useMemo(() => (Object.assign(Object.assign({}, cirrus), authenticatedCirrus)), [authenticatedCirrus, cirrus]);
}
exports.useAuthenticatedCirrus = useAuthenticatedCirrus;
//# sourceMappingURL=useAuthenticatedCirrus.js.map